import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import Dialog from '../../Services/Common/Dialog';
import DatePicker from '../../Components/Datepicker_Basic';
import CardH3 from '../../Components/Card_H3';
import FormGroup from '../../Components/Form_Group';
import InputBasic from '../../Components/Input_Basic';
import GridModal from '../../Components/Modal_Grid';
import AgDatePicker from '../../Components/agGrid/ag-DatePicker';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';
function ST10010(props) {
    React.useEffect(() => {
        document.title = '재고조사정보조회';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '재고관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>재고조사정보조회</strong>" +
            '</h1>';
    }, []);
    const gridRef = React.useRef();
    const columnDefs = [
        //재고조사일
        {
            field: 'stocktakingDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_StockTakingDate' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 140,
        },

        //사업장
        {
            field: 'plantCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PlantCd' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
            cellRenderer: Commons.CustomPlantRenderer,
        },

        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 250,
            editable: false,
        },
        //규격
        {
            field: 'itemStd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemStd1' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            cellStyle: { textAlign: 'center' },
            minWidth: 110,
        },

        //창고
        {
            field: 'whCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        //실사창고
        {
            field: 'checkWhCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CheckWh' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        //단위
        {
            field: 'itemUnit',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemUnit' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 90,
        },
        //품목단가
        {
            field: 'itemStdAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemCost' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            minWidth: 100,
        },
        //이전재고수량(BOM)
        {
            field: 'beforeStockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BeforeStockQty' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            cellRenderer: Commons.CustomNumberRenderer,
            aggFunc: 'sum',
            minWidth: 140,
            editable: false,
        },

        // //발주수량
        // {
        //   field: "stockAddQty",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_PoItemQty" && f.lanType === "COL"
        //         )[0].lanName
        //       : "",
        //   cellStyle: { textAlign: "right" },
        //   cellRenderer: Commons.CustomNumberRenderer,
        //   minWidth: 110,
        // },
        //현재재고수량
        {
            field: 'stockQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CurrentStock' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            cellRenderer: Commons.CustomNumberRenderer,
            aggFunc: 'sum',
            minWidth: 140,
            editable: false,
        },
        //실사수량
        {
            field: 'ckeckQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CheckQty' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            cellStyle: { textAlign: 'right' },
            cellRenderer: Commons.CustomNumberRenderer,
            aggFunc: 'sum',
            minWidth: 140,
        },
        //차이수량
        {
            field: 'needQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_NeedQty' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            cellStyle: { textAlign: 'right' },

            cellRenderer: Commons.CustomNumberRenderer,
            aggFunc: 'sum',
            minWidth: 140,
        },
        //이전재고금액
        {
            field: 'beforeSoItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_BeforSoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            // valueFormatter: (params) => {
            //   var formatted = params.value
            //     ? params.value
            //         .toString()
            //         .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
            //     : "0";
            //   return formatted;
            // },
            cellRenderer: Commons.CustomNumberRenderer,
            aggFunc: 'sum',
            minWidth: 100,
        },
        //금액
        {
            field: 'soItemAmt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoItemAmt' && f.lanType === 'COL')[0].lanName
                    : '',
            cellStyle: { textAlign: 'right' },
            // valueFormatter: (params) => {
            //   var formatted = params.value
            //     ? params.value
            //         .toString()
            //         .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
            //     : "0";
            //   return formatted;
            // },
            cellRenderer: Commons.CustomNumberRenderer,
            aggFunc: 'sum',
            minWidth: 100,
        },

        //대분류
        {
            field: 'lCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Lcategory' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //중분류
        {
            field: 'mCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Mcategory' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //소분류
        {
            field: 'sCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Scategory' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
        },
        //품목그룹
        {
            field: 'itemGroup',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemGroupNm' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        },
        //품목카테고리
        {
            field: 'itemCatego',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCategory' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 130,
        },
        //프로젝트명
        {
            field: 'projectNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ProjectNm' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 150,
        },
        //담당자
        {
            field: 'personCharg',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PersonCharg' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        },
        //비고
        {
            field: 'remark',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Remark' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 150,
        },
        //LOT_NO
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        }, //품목코드
        {
            field: 'itemCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemCd' && f.lanType === 'COL')[0].lanName
                    : '',
            editable: false,
            minWidth: 110,
        },
    ];

    const onCellClicked = (e) => {
        const selected = e.data;
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '100%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        재고조사일
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px', marginLeft: '5px' }}
                            selected={props.startDate}
                            onChange={(e) => {
                                props.setStartDate(e);
                            }}
                        />
                        ~
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px', marginLeft: '5px' }}
                            selected={props.endDate}
                            onChange={(e) => {
                                props.setEndDate(e);
                            }}
                        />
                    </div>
                    <AuthGroupButton
                        pageName="ST10010"
                        target="G01"
                        refreshNone="none"
                        selectFunc={() => {
                            props.SearchLogic();
                        }}
                    />
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        groupIncludeTotalFooter={true}
                        defaultColDef={{
                            flex: 1,
                            editable: true,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                            editable: false,
                        }}
                        rowData={props.rowData}
                        rowSelection="multiple"
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        onCellClicked={onCellClicked}
                        // suppressRowClickSelection={true}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        groupDefaultExpanded={1}
                        suppressAggFuncInHeader={true}
                        enableCellChangeFlash={true}
                        // getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                    />
                </div>
            </div>
        </div>
    );
}

export default ST10010;
